import React from 'react';
import './label.css';
import '../../../../styles/global.css';
import { Badge, Icon } from '@nooz-optics/nooz-components-lib';
import { ILabel } from 'utils/types/contentful';
import clsx from 'clsx';

const returnSizeVariant = (size: string) => {
  switch (size) {
    case 'inherit':
      return '';
    case 'xs':
      return 'text-xs';
    case 'sm':
      return 'text-xs md:text-sm';
    case 'base':
      return 'text-sm md:text-base';
    case 'lg':
      return 'text-base md:text-lg';
    case 'xl':
      return 'text-base md:text-xl';
    case '2xl':
      return 'text-xl md:text-2xl';
    case '3xl':
      return 'text-2xl md:text-3xl';
    case '4xl':
      return 'text-3xl md:text-4xl';
    case '5xl':
      return 'text-4xl md:text-5xl';
    case '6xl':
      return 'text-5xl md:text-6xl';
    case '7xl':
      return 'text-6xl md:text-7xl';
    case '8xl':
      return 'text-7xl md:text-8xl';
    default:
      return '';
  }
};

export const Label = ({
  align,
  badge,
  color,
  decoration,
  dotColor,
  htmlFor,
  icon,
  italic,
  lineHeight,
  notificationColor,
  size,
  text,
  transform,
  truncate,
  type = 'p',
  weight = 'normal',
  family,
}: ILabel) => {
  const Element = React.createElement(
    type || 'p',
    {
      className: clsx(family || 'font-gilmer', returnSizeVariant(size), {
        [`leading-${lineHeight} md:leading-${lineHeight}`]: lineHeight,
        [`font-${weight}`]: weight,
        [`text-${color?.classname}`]: color,
        [truncate]: truncate,
        [italic]: italic,
        [transform]: transform,
        [decoration]: decoration,
        [align]: align,
      }),
      htmlFor,
    },
    dotColor ? (
      <>
        {text}
        <span
          className={`${returnSizeVariant(size)} inline text-${
            dotColor?.classname
          }`}>
          .
        </span>
      </>
    ) : (
      text
    )
  );

  // ADD NOTIFICATION DOT
  if (notificationColor) {
    return (
      <div className='relative w-max flex items-center'>
        {Element}
        <span
          className={`w-2 h-2 top-0 -right-2 absolute rounded-full bg-${notificationColor.classname}`}
        />
      </div>
    );
  }

  // ADD BADGE TO THE RIGHT OF A LABEL
  if (badge) {
    return (
      <div className='flex items-center'>
        {Element}
        <div className='ml-2'>
          <Badge {...badge} />
        </div>
      </div>
    );
  }

  // ADD ICON TO THE RIGHT OF A LABEL
  if (icon) {
    return (
      <div className='flex items-center'>
        {Element}
        <div className='flex w-5 justify-center items-center ml-1 h-full'>
          <Icon {...icon} />
        </div>
      </div>
    );
  }

  return Element;
};
